/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Clear_SelectionInputs */

const en_ui_clear_selection = /** @type {(inputs: Ui_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear selection`)
};

/** @type {(inputs: Ui_Clear_SelectionInputs) => LocalizedString} */
const ar_ui_clear_selection = en_ui_clear_selection;

/** @type {(inputs: Ui_Clear_SelectionInputs) => LocalizedString} */
const he_ui_clear_selection = en_ui_clear_selection;

/** @type {(inputs: Ui_Clear_SelectionInputs) => LocalizedString} */
const ur_ui_clear_selection = en_ui_clear_selection;

/** @type {(inputs: Ui_Clear_SelectionInputs) => LocalizedString} */
const es_ui_clear_selection = en_ui_clear_selection;

/** @type {(inputs: Ui_Clear_SelectionInputs) => LocalizedString} */
const fr_ui_clear_selection = en_ui_clear_selection;

/** @type {(inputs: Ui_Clear_SelectionInputs) => LocalizedString} */
const de_ui_clear_selection = en_ui_clear_selection;

/** @type {(inputs: Ui_Clear_SelectionInputs) => LocalizedString} */
const pt_ui_clear_selection = en_ui_clear_selection;

/** @type {(inputs: Ui_Clear_SelectionInputs) => LocalizedString} */
const hi_ui_clear_selection = en_ui_clear_selection;

/** @type {(inputs: Ui_Clear_SelectionInputs) => LocalizedString} */
const bn_ui_clear_selection = en_ui_clear_selection;

/**
* | output |
* | --- |
* | "Clear selection" |
*
* @param {Ui_Clear_SelectionInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_clear_selection = /** @type {((inputs?: Ui_Clear_SelectionInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Clear_SelectionInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_clear_selection(inputs)
	if (locale === "he") return he_ui_clear_selection(inputs)
	if (locale === "ur") return ur_ui_clear_selection(inputs)
	if (locale === "es") return es_ui_clear_selection(inputs)
	if (locale === "fr") return fr_ui_clear_selection(inputs)
	if (locale === "de") return de_ui_clear_selection(inputs)
	if (locale === "pt") return pt_ui_clear_selection(inputs)
	if (locale === "hi") return hi_ui_clear_selection(inputs)
	if (locale === "bn") return bn_ui_clear_selection(inputs)
	return /** @type {LocalizedString} */ ("Clear selection")
});